import auth from '@/router/auth'
import ClassLiveIndex from '@/components/class-live/Index'
import ClassLiveShow from '@/components/class-live/Show'
import ClassLiveCreate from '@/components/class-live/Create'
// import BookingUpdate from '@/components/bookings/Update'
// import BookingShow from '@/components/bookings/Show'

export default [
  {
    path: '/class-live',
    name: 'class-live-index',
    component: ClassLiveIndex,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/class-live/create',
    name: 'class-live-create',
    component: ClassLiveCreate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/class-live-show/:id',
    name: 'class-live-show',
    component: ClassLiveShow,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/class-live-create-of-class/:id',
    name: 'class-live-create-of-class',
    component: ClassLiveCreate,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/class-live/router.js